import axios from 'axios';

const REACT_APP_EMERGENCY_URL = process.env.REACT_APP_EMERGENCY_URL; // 後端急診 proxy

export interface EmergencyItem {
  hospitalId: string; // 對應 facilities.code / 健保署 hosP_ID
  hospitalName: string;
  waitBedCount: number | null; // 住院
  waitSeeCount: number | null; // 看診
  waitGeneralCount: number | null; // 推床
  waitIcuCount: number | null; // 加護病房
  inform119Full: string; // 是否已向 119 通報滿床：'Y' / 'N'
  textUpdatedAt: string;
  sourceUrl?: string; // 此筆資料來源頁（僅特定醫院；覆蓋預設衛福部連結）
  sourceLabel?: string; // 來源連結顯示文字
}

export interface EmergencyResult {
  updatedAt: string;
  items: EmergencyItem[];
}

const EMPTY: EmergencyResult = { updatedAt: '', items: [] };

/**
 * 取得基隆區急診即時待診資訊（經後端 proxy 代打健保署 API）。
 * 失敗回空結果，讓診所列表頁照常顯示、僅不顯示急診項目。
 */
export const getEmergencyWaitInfo = async (): Promise<EmergencyResult> => {
  try {
    const response = await axios.post(`${REACT_APP_EMERGENCY_URL}`, {
      AREA_NO: '11',
      CONT_TYPE: '',
    });
    // 後端回 { status_code, data: { updatedAt, items } }
    return response.data?.data ?? EMPTY;
  } catch (error) {
    console.error('Error fetching emergency wait info:', error);
    return EMPTY;
  }
};
